<!--

  @copyright Copyright (c) Open-Xchange GmbH, Germany <info@open-xchange.com>
  @license AGPL-3.0

  This code is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with OX App Suite. If not, see <https://www.gnu.org/licenses/agpl-3.0.txt>.

  Any use of the work other than as authorized under this license or copyright law is prohibited.

-->

<template>
  <div class="notification-banner flex md:items-center">
    <div class="w-16 min-w-16 md:w-10 md:min-w-10 text-right md:text-center pe-3 md:px-0">
      <BaseIcon v-if="failed" class="bi-18 shrink-0 text-attention" icon-name="bi/exclamation-triangle-fill.svg"/>
      <BaseIcon v-else-if="props.iconName" class="bi-18 shrink-0" :icon-name="props.iconName"/>
    </div>
    <div class="flex-grow text-xs">
      <div class="font-medium text-xs" tabindex="0">{{ props.bannerText }}</div>
      <div v-if="failed" class="font-bold">
        {{ props.errorMessage }}
      </div>
      <div>
        <BaseButton
          v-if="cancelFunction"
          class="btn btn-link justify-start text-xs p-0 grow-0"
          @click="props.cancelFunction"
          :aria-label="props.buttonAriaLabel">
          {{ props.buttonText }}
        </BaseButton>
      </div>
    </div>
    <div class="pe-4">
      <IconButton
        class="btn btn-toolbar close-section -mt-1 md:mt-0"
        icon="bi/x.svg"
        iconClass="bi-16"
        :title="i18n.title"
        :ariaLabel="i18n.title"
        @click="close"
      />
    </div>
  </div>
</template>

<script setup>
import BaseIcon from '@/io.ox/vueComponents/base-icon.vue'
import BaseButton from '@/io.ox/vueComponents/base-button.vue'
import IconButton from '@/io.ox/vueComponents/icon-button.vue'
import gt from 'gettext'

const props = defineProps(({
  bannerText: { type: String, required: true },
  cancelFunction: { type: Function, required: false },
  buttonAriaLabel: { type: String, required: false },
  buttonText: { type: String, required: false, default: gt('Cancel') },
  iconName: { type: String, required: false, default: 'bi/clock.svg' },
  close: { type: Function },
  errorMessage: { type: String, required: false, default: '' }
}))

const failed = props.errorMessage !== ''

const i18n = {
  title: gt('Close banner')
}
</script>

<style lang="scss" scoped>
.notification-banner {
  padding-block: 8px;
  background-color: var(--accent-20);
}
html.dark .notification-banner {
  background-color: transparent;
}
</style>
